import { render, staticRenderFns } from "./DrilldownPanel.vue?vue&type=template&id=1315de97&scoped=true"
import script from "./DrilldownPanel.vue?vue&type=script&lang=js"
export * from "./DrilldownPanel.vue?vue&type=script&lang=js"
import style0 from "./DrilldownPanel.vue?vue&type=style&index=0&id=1315de97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315de97",
  null
  
)

export default component.exports